<template>
  <div id="app">
    <!-- Preloader Start -->
    <HeaderComp />
    <!-- Preloader Start -->

    <!-- Slider Area Start-->
    <div class="services-area">
      <div class="container">
        <!-- Section-tittle -->
        <div class="row d-flex justify-content-center">
          <div class="col-lg-8">
            <div class="section-tittle text-center mb-80">
              <h2 class="mb-5">
                <div class="to-see">To see :</div>
                <i>{{title}}</i>
              </h2>
              <a :href="downloadLink">
                <h2 class="d-block btn mb-5">Download App​</h2>
              </a>
              <a :href="'nanichat://custom/p/'+id">
                <h2 class="d-block btn">Open in App​</h2>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Slider Area End-->

    <!-- ================ contact section start ================= -->
    <!-- <section class="contact-section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="contact-title">Get in Touch</h2>
          </div>
          <div class="col-12">
            <a>Open in App</a>
          </div>
        </div>
      </div>
    </section>-->
    <!-- ================ contact section end ================= -->
    <!-- <FooterComp /> -->
  </div>
</template>

<script>
import HeaderComp from "./sub/Header";
import FooterComp from "./sub/Footer";
import UAParser from "ua-parser-js";
export default {
  name: "App",
  data() {
    return {
      year: new Date().getFullYear(),
      downloadLink: "",
      title: "",
      id: ""
    };
  },
  async mounted() {
    this.downloadLink = "https://nani.chat/";
    var agent = UAParser(navigator.userAgent);
    console.log(agent);
    if (agent.os.name == "Android") {
      this.downloadLink = config.downloadLinks.android;
    }
    if (agent.os.name == "iOS") {
      this.downloadLink = config.downloadLinks.ios;
    }

    this.id = this.$route.params.id;
    //get
    let response = await this.$axios.post(config.url.post.get, {
      id: this.id
    });
    console.log(response.data);
    this.errors = response.data.errors;
    if (this.errors.length != 0) {
      //bad
    }
    this.title = response.data.title;
    document.title = "Nani Chat - " + this.title;
  },
  methods: {
    async sendMail() {
      let response = await this.$axios.post(
        "http://localhost:8085/api/frontend/sendmail",
        {
          message: this.message,
          name: this.name,
          email: this.email,
          subject: this.subject
        }
      );
      console.log(response.data);
    }
  },
  components: { HeaderComp }
};
</script>

<style scoped>
.to-see {
  font-size: 0.8;
}
</style>
